import styled from '@emotion/styled'
import { theme as newTheme } from 'styles/theme/hav-theme'
import { DivProps } from 'commons/types/htmlElements'

interface WrapLabelStyledProps extends DivProps {
  hasInfo?: string
}
interface FormControlStyledProps extends DivProps {
  width?: number
}

interface WrapIconStyledProps extends DivProps {
  justifyContent: string
  disabled?: boolean
}

interface FieldStyledProps extends DivProps {
  errorOutline?: boolean
  disabled?: boolean
  padding?: number | string
}

export const FieldStyled = styled.div<FieldStyledProps>`
  background-color: ${newTheme.colors.neutral.white};
  border: 1px solid
    ${({ errorOutline }) =>
      errorOutline ? newTheme.colors.support.error : newTheme.colors.neutral.lighthover};
  box-sizing: border-box;
  border-radius: ${newTheme.spacing.xs};
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  margin: ${newTheme.spacing.xs} 0px;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  input[type='file'] {
    display: none;
  }
  padding: ${({ padding }) => (padding ? padding : newTheme.spacing.xm)};

  label {
    color: ${newTheme.colors.primary.main};
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  }
`
export const WrapLabelStyled = styled.div<WrapLabelStyledProps>`
  display: flex;
  flex-direction: row;
  #LabelInputForm {
    align-self: end;
    margin-bottom: ${newTheme.spacing.xs};
    line-height: ${newTheme.typography.sizes.xs};
    ${({ hasInfo }) => hasInfo && ` margin-right: ${newTheme.spacing.xs}; `}
  }
`
export const WrapIconStyled = styled.div<WrapIconStyledProps>`
  display: flex;
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent};

  svg {
    margin-right: ${newTheme.spacing.xs};
    path {
      ${({ disabled }) => disabled && `fill: ${newTheme.colors.neutral.lighthover};`}
    }
  }

  span {
    overflow: hidden;
    text-decoration: underline;
    font-size: ${newTheme.typography.sizes.xs};
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    ${({ disabled }) => disabled && `color: ${newTheme.colors.neutral.lighthover};`}
  }

  #asterisk {
    color: ${newTheme.colors.secondary};
    text-decoration: none;
    margin-left: 2px;
  }
`

export const FormControlStyled = styled.div<FormControlStyledProps>`
  ${({ width }) => width && `width: ${width}px; `}
`
